import dialog from "@/presets/lara/dialog";

export const internalCommentsCardPt = {
  root: {
    class: "bg-white rounded-lg border border-gray-175 px-6 pt-5 pb-6 mt-[18px] text-indigo-base",
  },
  header: {
    class: "flex items-center gap-2.5 pb-3.5 border-b border-gray-175",
  },
  body: {
    class: "p-0",
  },
  content: {
    class: "p-0",
  },
};

export const deleteCommentDialogPt = {
  ...dialog,
  root: (options: { state: Record<string, unknown> }) => ({
    class: [dialog.root(options).class, "flex flex-col overflow-hidden !rounded-xl"],
  }),
  header: {
    class: "flex items-center gap-3 px-5 py-4 bg-teal-light text-indigo-base",
  },
  icons: {
    class: "flex items-center ml-auto",
  },
  closeButton: {
    class:
      "inline-flex items-center justify-center w-7 h-7 rounded border-0 bg-transparent text-teal-900 hover:bg-white/60 focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-900",
  },
  content: () => ({
    class: "p-6 bg-white",
  }),
  footer: {
    class: "flex justify-end gap-3 px-6 py-4 border-t border-gray-175 bg-blue-100",
  },
};
